import { ReactNode } from 'react';

import { ConfigGuard } from '@occc-app/App/guards';
import { Can } from '@occc-app/App/PolicyBasedAccessControl/components/Can';
import { CreateRetailerNetwork } from '@occc-app/App/PolicyBasedAccessControl/userActions';
import UnauthorizedPage from '@occc-app/routes/Unauthorized';

type RetailerNetworkCreatePageGuardProps = {
  children: ReactNode;
};

export const RetailerNetworkCreatePageGuard = ({
  children,
}: RetailerNetworkCreatePageGuardProps) => (
  <ConfigGuard
    isFeatureEnabled={(config) =>
      config.retailerConnect.enabled && config.retailerConnect.networkManagementEnabled
    }
  >
    <Can I={CreateRetailerNetwork()} fallback={<UnauthorizedPage />}>
      {children}
    </Can>
  </ConfigGuard>
);
